import { Checkbox, FormControlLabel, FormGroup, Grid } from "@mui/material";
import {
  deleteAdvFilesByIdRequest,
  getAdvByIdRequest,
  updateAdvByIdRequest,
} from "api/adv";
import UploadCm from "components/AdvsUploadCm";
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import StackCm from "components/shared/StackCm";
import TextFieldCm from "components/shared/TextField";
import {
  ATTR_OPTIONS,
  DEAL_TYPES,
  DOCUMENT_TYPES,
  MAIN_SUB_CATEGORY,
  PLACE_TYPES,
} from "constants/advOptions";
import { categoriesData } from "constants/category";
import Toast from "helper/toast";
import useHttp from "hooks/use-http";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { StyledGlBtn, StyledGlTitle } from "styles/globals";

const INPUTS = [
  {
    id: "title",
    label: "عنوان",
    rows: 2,
  },
  {
    id: "age",
    label: "سن",
    type: "number",
  },
  {
    id: "floor",
    label: "طبقه",
    type: "number",
  },
  {
    id: "meterage",
    label: "متراژ",
    type: "number",
  },
  {
    id: "room_count",
    label: "تعداد اتاق",
    type: "number",
  },
  {
    id: "main_sub_category",
    label: "زیردسته اصلی",
    selectItems: MAIN_SUB_CATEGORY,
    type: "select",
  },
  {
    id: "deal_type",
    label: "نوع قرارداد",
    selectItems: DEAL_TYPES,
    type: "select",
  },
  {
    id: "place_type",
    label: "نوع ملک",
    selectItems: PLACE_TYPES,
    type: "select",
  },
  {
    id: "document_type",
    label: "نوع سند",
    selectItems: DOCUMENT_TYPES,
    type: "select",
  },
  {
    id: "category",
    label: "محله",
    selectItems: categoriesData,
    type: "select",
  },
];

export default function EditAdv() {
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  // IMAGE
  const [image1, setImage1] = useState({
    url: null,
    isChanged: false,
  });

  const [image2, setImage2] = useState({
    url: null,
    isChanged: false,
  });

  const [image3, setImage3] = useState({
    url: null,
    isChanged: false,
  });

  const [video, setVideo] = useState({
    url: null,
    isChanged: false,
  });

  const [videoImage, setVideoImage] = useState({
    url: null,
    isChanged: false,
  });

  const [attributes, setAttributes] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);

  const deleteFile = async (data) => {
    const res = await request({
      url: () =>
        deleteAdvFilesByIdRequest({
          ...data,
          id,
        }),
    });
    if (res) {
      //   Toast({ type: "success", title: "ویرایش آگهی" });
      getDataById();
    }
  };
  const onSubmit = async (data) => {
    data.image_1 = image1.isWeb ? null : image1.url;
    data.image_2 = image2.isWeb ? null : image2.url;
    data.image_3 = image3.isWeb ? null : image3.url;
    data.video = video.isWeb ? null : video.url;
    data.img_video = videoImage.isWeb ? null : videoImage.url;
    data.attributes = Object.values(attributes).join(",");
    const res = await request({
      url: () =>
        updateAdvByIdRequest(
          {
            ...data,
            id,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });
    if (res) {
      Toast({ type: "success", title: "ویرایش آگهی" });
      getDataById();
    }
  };

  const getDataById = async () => {
    const altArr = [1, 2, 3];
    const res = await request({
      url: getAdvByIdRequest,
      values: id,
    });

    INPUTS.forEach((item) => setValue(`${item.id}`, res[item.id] || ""));
    altArr.forEach((item) => {
      setValue(`alt_${item}`, res[`image_${item}`].alt || "");
    });
    setImage1({
      isChanged: Boolean(res?.image_1.url),
      url: res?.image_1.url || null,
      isWeb: true,
    });
    setImage2({
      isChanged: Boolean(res?.image_2.url),
      url: res?.image_2.url || null,
      isWeb: true,
    });
    setImage3({
      isChanged: Boolean(res?.image_3.url),
      url: res?.image_3.url || null,
      isWeb: true,
    });
    setVideoImage({
      isChanged: Boolean(res?.img_video.url),
      url: res?.img_video.url || null,
      isWeb: true,
    });
    setVideo({
      isChanged: Boolean(res?.video),
      url: res?.video || null,
      isWeb: true,
    });
    setValue("sub_category", res.sub_category || "");
    setAttributes(res.attributes.split(",").map((item) => eval(item)));
    setValue("keyword", res?.seo_options?.keyword || "");
    setValue("meta_description", res?.seo_options?.meta_description || "");
  };
  useEffect(() => {
    getDataById();
  }, []);

  return (
    <DrawerCM title="ویرایش آگهی">
      <Grid container mt={3}>
        <BackButton />
      </Grid>
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <StackCm title="فیلد های آگهی">
          <Grid container>
            {INPUTS.map((input, index) => (
              <Grid
                key={input.id}
                item
                md={index === 0 ? 12 : 4}
                sm={index === 0 ? 12 : 6}
                xs={12}
                p={1.5}
              >
                <TextFieldCm
                  {...input}
                  register={register}
                  errors={errors}
                  control={control}
                />
              </Grid>
            ))}

            <Grid item md={4} sm={6} xs={12} p={1.5}>
              <TextFieldCm
                id={"sub_category"}
                type={"select"}
                label={"زیردسته"}
                selectItems={
                  watch("category") == 1 ? categoriesData[0].subCategories : []
                }
                register={register}
                errors={errors}
                control={control}
              />
            </Grid>

            <StyledGlTitle style={{ marginTop: "40px" }}>
              عکس و ویدئو
            </StyledGlTitle>
            <Grid item md={4} xs={12} p={1.5}>
              <UploadCm
                title={"بارگزاری عکس اول"}
                id={"image_1"}
                state={image1}
                setState={setImage1}
                handleDeleteReq={() => deleteFile({ image_1: null })}
              />
            </Grid>
            <Grid item md={4} xs={12} p={1.5}>
              <UploadCm
                title={"بارگزاری عکس دوم"}
                id={"image_2"}
                state={image2}
                setState={setImage2}
                handleDeleteReq={() => deleteFile({ image_2: null })}
              />
            </Grid>
            <Grid item md={4} xs={12} p={1.5}>
              <UploadCm
                title={"بارگزاری عکس سوم"}
                id={"image_3"}
                state={image3}
                setState={setImage3}
                handleDeleteReq={() => deleteFile({ image_3: null })}
              />
            </Grid>
            <Grid item md={6} xs={12} p={1.5}>
              <UploadCm
                type="video"
                title={"بارگزاری ویدئو"}
                state={video}
                setState={setVideo}
                handleDeleteReq={() => deleteFile({ video: null })}
              />
            </Grid>
            <Grid item md={6} xs={12} p={1.5}>
              <UploadCm
                title={"بارگزاری عکس ویدئو"}
                id={"image_video"}
                state={videoImage}
                setState={setVideoImage}
                handleDeleteReq={() => deleteFile({ img_video: null })}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12} p={1.5}>
              <TextFieldCm
                id="alt_1"
                label="متن جایگزین (alt 1)"
                register={register}
                errors={errors}
                control={control}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12} p={1.5}>
              <TextFieldCm
                id="alt_2"
                label="متن جایگزین (alt 2)"
                register={register}
                errors={errors}
                control={control}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12} p={1.5}>
              <TextFieldCm
                id="alt_3"
                label="متن جایگزین (alt 3)"
                register={register}
                errors={errors}
                control={control}
              />
            </Grid>
            <StyledGlTitle style={{ marginTop: "40px" }}>
              ویژگی ها
            </StyledGlTitle>
            {ATTR_OPTIONS.map((options, index) => (
              <Grid key={options.id} item md={4} sm={6} xs={12} p={1.5}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register(`attributes[${options.id}]`)}
                        checked={attributes[options.id]}
                        onChange={(e) => {
                          setAttributes((prevStatus, index) => ({
                            ...prevStatus,
                            [options.id]: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label={options.title}
                  />
                </FormGroup>
              </Grid>
            ))}
            <StyledGlTitle style={{ marginTop: "40px" }}>سئو</StyledGlTitle>
            <Grid item xs={12} p={1.5}>
              <TextFieldCm
                id="keyword"
                label="کلمات کلیدی"
                register={register}
                errors={errors}
                control={control}
              />
            </Grid>
            <Grid item xs={12} p={1.5}>
              <TextFieldCm
                id="meta_description"
                label="توضیحات"
                register={register}
                errors={errors}
                control={control}
                rows={2}
              />
            </Grid>
            <StyledGlBtn onClick={handleSubmit(onSubmit)} />
          </Grid>
        </StackCm>
      )}
    </DrawerCM>
  );
}
